module.exports = __webpack_public_path__ + "img/glider-emblem-black.3bb59efe.png";